import { render, staticRenderFns } from "./NewThemeCard.vue?vue&type=template&id=1889513b&scoped=true"
import script from "./NewThemeCard.vue?vue&type=script&lang=js"
export * from "./NewThemeCard.vue?vue&type=script&lang=js"
import style0 from "./NewThemeCard.vue?vue&type=style&index=0&id=1889513b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1889513b",
  null
  
)

export default component.exports